var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPhone = function SvgPhone(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 502,
    height: 502,
    viewBox: "0 0 502 502",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "phone",
    transform: "translate(-735 -300)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 251,
    cy: 251,
    r: 251,
    transform: "translate(735 300)",
    fill: "#fffae9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "phone-call_4_",
    "data-name": "phone-call (4)",
    transform: "translate(869 434)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M233.552,188.208a34.551,34.551,0,0,0-10.6-23.742c-12.742-12.287-23.418-19.38-33.6-22.321-14.026-4.054-27.019-.368-38.613,10.956l-.052.052L138.356,165.4a184.862,184.862,0,0,1-38.9-30.084l-1.2-1.2A184.881,184.881,0,0,1,68.178,95.22L80.422,82.884l.052-.052C91.8,71.238,95.483,58.246,91.43,44.218,88.488,34.039,81.4,23.363,69.108,10.621A34.72,34.72,0,0,0,20.924,8.884l-.262.235q-.182.164-.356.337C6.912,22.851-.108,41.6,0,63.681c.187,37.51,20.8,80.405,55.145,114.747a222.382,222.382,0,0,0,21.875,19.049A9.124,9.124,0,0,0,88.125,183a204.307,204.307,0,0,1-20.075-17.47C37.03,134.507,18.413,96.4,18.249,63.591c-.084-17.005,5.031-31.2,14.8-41.065l.07-.063a16.413,16.413,0,0,1,22.859.825c23.622,24.5,21.911,36.062,11.473,46.766L50.534,87.093a9.125,9.125,0,0,0-1.859,10.14c.429.964,10.817,23.917,36.685,49.786l1.2,1.2c25.866,25.866,48.819,36.253,49.783,36.682a9.123,9.123,0,0,0,10.139-1.859l17.04-16.914c10.7-10.438,22.27-12.148,46.766,11.474a16.412,16.412,0,0,1,.826,22.858l-.065.072c-9.785,9.685-23.828,14.8-40.648,14.8h-.417c-13.445-.067-29.013-3.753-45.022-10.658a9.124,9.124,0,0,0-7.227,16.756c18.5,7.982,36.053,12.069,52.158,12.15h.512c21.858,0,40.423-7.016,53.713-20.306.115-.116.228-.234.337-.356l.237-.263A34.55,34.55,0,0,0,233.552,188.208Z",
    transform: "translate(0 -0.002)",
    fill: "#ffc212"
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPhone);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/phone.ef6a74ad9291ebf26ea0017349f8211b.svg";